import React from "react";
import { Button, Empty } from "antd";
import { BackendStatusBadge, ReviewStatusBadge } from "./status_badges.component";
import { formatDateTime, formatDurationSeconds } from "../services/firestoreTracking.service";

export const OfflinePanel = ({ records = [], onSelect, providerName, providerStatus }) => {
  const longestGap = records.reduce((max, record) => {
    const nextValue = Number(record?.offlineDurationSeconds || record?.telemetryGapSeconds);
    if (!Number.isFinite(nextValue)) return max;
    return Math.max(max, nextValue);
  }, 0);

  return <div className="rounded-[32px] border border-[#1d1733] bg-[linear-gradient(180deg,#151022_0%,#0b0912_100%)] px-6 py-6 text-white shadow-[0_24px_70px_rgba(15,23,42,0.24)]">
    <div className="flex items-start justify-between gap-4">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.24em] text-[#a78bfa]">Offline Terminal</div>
        <div className="mt-2 text-[1.9rem] font-semibold leading-tight text-white">Offline Infringement Feed</div>
        <div className="mt-2 max-w-[520px] text-sm leading-7 text-[#b8afd1]">
          Each line is a no-connection interval while the driver phone is offline or the tracking runtime has stopped sending heartbeats.
        </div>
      </div>
      <div className="text-right">
        <div className="text-[1.6rem] font-semibold text-white">{records.length}</div>
        <div className="text-xs uppercase tracking-[0.18em] text-[#9f96bc]">Live events</div>
      </div>
    </div>
    <div className="mt-5 flex flex-wrap items-center justify-between gap-4 rounded-[24px] border border-white/10 bg-black/25 px-4 py-4">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#9f96bc]">Longest Gap</div>
        <div className="mt-2 text-[1.2rem] font-semibold text-white">
        {longestGap ? formatDurationSeconds(longestGap) : "No offline gaps yet"}
        </div>
      </div>
      <div className="text-right text-sm text-[#c6bddf]">
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#9f96bc]">Provider</div>
        <div className="mt-2">{providerName || "driver-tracking-telemetry"}</div>
        <div className="mt-1 uppercase tracking-[0.12em] text-[#8d82ad]">{providerStatus || "live-firestore"}</div>
      </div>
    </div>
    <div className="mt-5 rounded-[24px] border border-white/10 bg-black/25 px-4 py-4">
      <div className="grid grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_auto] gap-4 px-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#8d82ad]">
        <div>Log</div>
        <div>Status</div>
        <div>Checkpoint</div>
      </div>
      <div className="mt-4 flex flex-col gap-3">
      {records.length === 0 ? <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-5">
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-[#b8afd1]">No offline infringements logged for this trip yet.</span>} />
      </div> : records.slice(0, 6).map((record) => <div key={record.id} className="grid grid-cols-1 gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-4 md:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)_auto]">
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-white">{formatDateTime(record?.offlineStartedAt || record?.startTime)}</span>
          <span className="text-sm text-[#b8afd1]">{formatDurationSeconds(record?.offlineDurationSeconds || record?.telemetryGapSeconds || record?.outageDurationSeconds)}</span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
            <BackendStatusBadge status={record?.status} />
            <ReviewStatusBadge status={record?.reviewStatus} />
            {onSelect ? <Button onClick={() => onSelect?.(record)}>Review</Button> : null}
          </div>
          <div className="text-sm text-[#d7d0eb]">{formatDateTime(record?.printedAt || record?.checkpointTime || record?.endTime)}</div>
        </div>
      )}
      </div>
    </div>
  </div>;
};
